<template>
  <div>
    <div class="grid md:grid-cols-12 grid-cols-1 gap-5 mt-8 mb-12 w-full">
      <div
        class="border rounded-md bg-root text-root-2 md:col-span-6 flex items-center justify-between cursor-pointer py-8"
      >
        <div class="flex items-center justify-between px-4">
          <div class="p-2 mr-3.5">
            <customers-icon />
          </div>
          <div>
            <p class="text-13px font-light">All Customers</p>
            <p class="text-2xl font-bold">
              {{ page.totalCount }}
            </p>
          </div>
        </div>
      </div>
      <div
        class="border rounded-md bg-root md:col-span-6 text-root-2 flex items-center justify-between cursor-pointer py-8"
      >
        <div class="flex items-center justify-between px-4">
          <div class="p-2 mr-3.5">
            <transaction-icon />
          </div>
          <div>
            <p class="text-13px font-light">Total Number of Transactions</p>
            <p class="text-2xl font-bold">
              {{ externalApiDashboardInformation.transactionCount }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- search and filter -->
    <div class="hidden md:block">
      <div class="flex justify-between items-center border-b pb-3">
        <p>All Customers</p>
        <div class="flex items-center gap-x-3">
          <div class="-mb-5">
            <el-form>
              <el-form-item>
                <el-input v-model="search" placeholder="Search Customers Name">
                  <i
                    slot="prefix"
                    :size="40"
                    class="el-input__icon el-icon-search"
                  ></i>
                </el-input>
              </el-form-item>
            </el-form>
          </div>
          <div
            class="flex items-center gap-x-1 border border-root-3 text-root-2 px-3.5 xl:px-2.5 lg:py-2 py-2.5 rounded-lg cursor-pointer"
            @click="showDialog('showTableFilter')"
          >
            <filter-icon />
            <p class="text-black-2 text-sm px-2 font-normal">Filter</p>
            <div class="">
              <arrow-down-icon />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-8">
      <all-customers-table
        :tableData="customersInfo"
        :page="page"
        @getCustomers="getCustomers"
        tableType="allCustomersTable"
      />
    </div>
    <div class="p-6 grid grid-cols-1 md:justify-items-end">
      <!-- dialogs -->
      <filter-dialog
        :showDialog="showTableFilter"
        @filterParams="searchFilterParams"
        @closeDialog="closeDialog('showTableFilter')"
        @cancel="handleCancel"
      />
    </div>
  </div>
</template>
<script>
import getCustomers from '@/mixins/externalApi'
import applyDateFilter from '@/mixins/app.js'
import _ from 'lodash'
export default {
  name: 'AllCustomers',
  mixins: [getCustomers, applyDateFilter],
  data () {
    return {
      defaultPayload: null,
      showTableFilter: false,
      search: '',
      isLoading: false,
      payload: {
        page: 1,
        size: 10,
        status: '',
        type: '',
        from: '',
        to: '',
        search: ''
      }
    }
  },
  components: {
    AllCustomersTable: () =>
      import('@/components/v2/externalApi/tables/AllCustomersTable.vue'),
    TransactionIcon: () => import('@/assets/v2/icons/TransactionIcon.vue'),
    CustomersIcon: () => import('@/assets/v2/icons/CustomersIcon.vue'),
    ArrowDownIcon: () => import('@/assets/v2/icons/ArrowDownTwo.vue'),
    FilterIcon: () => import('@/assets/v2/icons/FilterIcon.vue'),
    FilterDialog: () =>
      import('@/components/v2/bulkPayout/dialogs/FilterDialog.vue')
  },
  methods: {
    searchFilterHandler: _.debounce(function () {
      this.payload.search = this.search
      this.getCustomers()
    }, 1000),
    searchFilterParams (filterParams) {
      this.applyDateFilter(filterParams)
      this.getCustomers()
    },
    showDialog (dialog) {
      this[dialog] = true
    },
    closeDialog (dialog) {
      this[dialog] = false
    },
    handleCancel () {
      this.search = ''
      this.payload = this.defaultPayload
      this.getCustomers()
    }
  },
  computed: {
    customersInfo () {
      return this.$store.state.externalApi.customers.items || []
    },
    page () {
      return this.$store.state.externalApi.customers.page || {}
    },
    externalApiDashboardInformation () {
      return this.$store.state.externalApi.externalApiDashboard
    }
  },
  watch: {
    search (value) {
      this.searchFilterHandler()
    }
  },
  mounted () {
    this.getCustomers()
    this.getExternalApiDashboardInformation()
  }
}
</script>
<style scoped>
>>> .el-input__inner {
  height: 40px;
  border-radius: 8px;
}
</style>
